module.exports = __webpack_public_path__ + "static/media/globe-europe.80a0bef4.svg";